import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';

const NewOrExistingPatient = ({
  title = 'Welcome',
  subtitle = 'To get started, please tell us a little bit about yourself',
  stepNum,
  onSubmit
}) => {
  return (
    <Stack spacing={4} alignItems='center'>
      {/* <Avatar
        variant='rounded'
        style={{backgroundColor: config().colors.primary}}
        sx={{width: 56, height: 56}}
      >
        <LocationPinIcon />
      </Avatar> */}
      <Stack spacing={0.5} alignItems='center'>
        <Typography variant='h2'>{title}</Typography>
        <Typography>{subtitle}</Typography>
      </Stack>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          fullWidth
          options={[
            {
              value: true, 
              label: 'I\'m a new client',
              emoji: '✨',
              xs: 12,
              md: 6,
              lg: 6,
              xl: 6,
            },
            {
              value: false,

              label: 'I already have an account',
              emoji: '👋',
              xs: 12,
              md: 6,
              lg: 6,
              xl: 6,
            },
          ]}
          onChange={(e, val) => onSubmit(e, val)}
        />
      </Box>
    </Stack>
  );
};

export default NewOrExistingPatient;